import React from 'react';
import Styled from './styles';
import { Button, TextField, Select } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { FormControl, MenuItem } from 'material-ui';
import api from '../../../lib/api';
import LinkGenerated from '../LinkGenerated';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: 0
  },
  textField: {
    marginRight: theme.spacing.unit,
    width: 276,
    border: '1px solid #C4C4C4',
    borderRadius: '5px',
    padding: '10px'
  },
  input: {
    fontSize: 16,
    fontWeight: 'normal',
    '&[type=number]': {
      '-moz-appearance': 'textfield'
    },
    '&::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    },
    '&::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  },
  button: {
    backgroundColor: '#42FFBB',
    color: 'black',
    fontSize: 14,
    fontWeight: 900,
    borderRadius: 8,
    padding: '15px',
    '&:hover': {
      backgroundColor: '#42FFBB'
    }
  }
});
class GenerateEmandateLink extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      showLinkGenerated: false,
      name: '',
      phoneNumber: '',
      email: '',
      planDetails: '',
      companyId: '',
      companyName: '',
      userPhone: '',
      userEmail: '',
      firstCharge: '',
      errorMessage: '',
      planType: 'GROWTH',
      originalAmount: '',
      duration: '',
      installments: '',
      installmentDuration: '',
      emandateLink: '',
      errorCompanyID: false,
      errorDuration: false,
      errorName: false,
      errorPhoneNumber: false,
      errorEmail: false,
      errorPlanDetails: false,
      errorPlanAmount: false,
      errorGeneratedLink: false,
      errorFirstCharge: false,
      disableTextField: true,
      prorationNeeded: false,
      loading: false
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.companyId && this.state.companyId !== prevState.companyId) {
      api
        .getSalesType(this.state.companyId)
        .then(({ salesType, prorationNeeded }) => {
          this.setState({ salesType, prorationNeeded });
        })
        .catch(reason => console.log(reason));
    }
  }

  companyIdChange = e => {
    if (!e.target.value) {
      this.setState({
        companyName: '',
        userPhone: '',
        userEmail: ''
      });
    }
    this.setState({ companyId: e.target.value, errorCompanyID: false });
  };
  getCompanyDetails = async e => {
    e.preventDefault();
    e.stopPropagation();

    if (e.target.value) {
      try {
        this.setState({ loading: true, disableTextField: true });
        const {
          target: { value }
        } = e;
        let companyId = value;
        let {
          companyName,
          userPhone,
          userEmail
        } = await api.getCompanyIdDetails(companyId);
        this.setState({
          companyName: companyName,
          userPhone: userPhone,
          userEmail: userEmail,
          loading: false,
          disableTextField: false,
          email: userEmail,
          phoneNumber: userPhone.substring(3)
        });
      } catch (error) {
        console.log(error.response.statusText);

        this.setState({
          companyName: '',
          userPhone: '',
          userEmail: '',
          loading: false,
          disableTextField: true,
          errorCompanyID: true,
          email: '',
          phoneNumber: ''
        });
      }
    }
  };

  onNameChange = event => {
    const { value } = event.target;
    this.setState({ name: value, errorName: false });
  };
  onPhoneNumberChange = event => {
    const { value } = event.target;
    this.setState({ phoneNumber: value, errorPhoneNumber: false });
  };
  onPlanDetailsChange = event => {
    const { value } = event.target;
    this.setState({ planDetails: value, errorPlanDetails: false });
  };
  onEmailChange = event => {
    const { value } = event.target;
    this.setState({ email: value, errorEmail: false });
  };
  onDurationChange = e => {
    e.preventDefault();
    e.stopPropagation();
    const {
      target: { value }
    } = e;
    this.setState({ duration: value, errorDuration: false });
  };
  onInstallmentsChange = e => {
    e.preventDefault();
    e.stopPropagation();
    const {
      target: { value }
    } = e;
    this.setState({ installments: value, errorInstallments: false });
  };
  onInstallmentDurationChange = e => {
    e.preventDefault();
    e.stopPropagation();
    const {
      target: { value }
    } = e;
    this.setState({
      installmentDuration: value,
      errorInstallmentDuration: false
    });
  };
  planMaxAmountChange = e => {
    const {
      target: { value }
    } = e;
    this.setState({
      originalAmount: value,
      errorPlanAmount: false
    });
  };
  firstChargeChange = e => {
    const {
      target: { value }
    } = e;
    this.setState({
      firstCharge: value,
      errorFirstCharge: false
    });
  };
  onChangeType = e => {
    e.preventDefault();
    e.stopPropagation();
    const {
      target: { value }
    } = e;
    this.setState({ planType: value });
  };

  validateForm = () => {
    let errorFlag = false;
    if (!this.state.companyId || this.state.errorCompanyID) {
      errorFlag = true;
      this.setState({ errorCompanyID: true });
    }
    if (!this.state.name) {
      errorFlag = true;
      this.setState({ errorName: true, name: '' });
    }
    if (!this.state.email) {
      errorFlag = true;
      this.setState({ errorEmail: true, email: '' });
    }
    if (
      !this.state.phoneNumber ||
      !/^[0-9]{10}$/.test(this.state.phoneNumber)
    ) {
      errorFlag = true;
      this.setState({ errorPhoneNumber: true, phoneNumber: '' });
    }
    if (!this.state.planDetails) {
      errorFlag = true;
      this.setState({ errorPlanDetails: true, planDetails: '' });
    }
    if (!this.state.firstCharge) {
      errorFlag = true;
      this.setState({ errorFirstCharge: true, firstCharge: '' });
    }
    if (
      !this.state.duration ||
      Number(this.state.duration) > 120 ||
      Number(this.state.duration) < 1
    ) {
      errorFlag = true;
      this.setState({ errorDuration: true, duration: '' });
    }
    console.log(
      'typeof this.state.duration',
      typeof this.state.duration,
      this.state.duration
    );
    console.log(
      'typeof this.state.installmentDuration',
      typeof this.state.installmentDuration,
      this.state.installmentDuration
    );
    if (!this.state.installments || isNaN(this.state.duration)) {
      errorFlag = true;
      this.setState({ errorInstallments: true, installments: '' });
    }
    if (
      !this.state.installmentDuration ||
      isNaN(this.state.installmentDuration) ||
      Number(this.state.installmentDuration) +
        Number(this.state.installments) *
          Number(this.state.installmentDuration) >
        Number(this.state.duration)
    ) {
      errorFlag = true;
      this.setState({
        errorInstallmentDuration: true,
        installmentDuration: ''
      });
    }
    if (!this.state.originalAmount || Number(this.state.originalAmount) < 500) {
      errorFlag = true;
      this.setState({
        errorPlanAmount: true,
        originalAmount: ''
      });
    }
    if (this.state.prorationNeeded) {
      errorFlag = true;
    }

    return errorFlag;
  };
  onGenerateLink = async () => {
    this.setState({
      errorGeneratedLink: false
    });
    let errorFlag = this.validateForm();
    if (errorFlag) {
      return;
    }
    const formData = {
      planType: this.state.planType,
      duration: +this.state.duration,
      installments: +this.state.installments,
      installmentDuration: +this.state.installmentDuration,
      name: this.state.name,
      email: this.state.email,
      phoneNumber: this.state.phoneNumber,
      description: this.state.planDetails,
      amount: this.state.originalAmount,
      firstCharge: this.state.firstCharge,
      companyId: this.state.companyId
    };
    try {
      const {
        data: { short_url }
      } = await api.generateEmandateLink(formData);
      this.setState({
        emandateLink: short_url,
        showLinkGenerated: !this.state.showLinkGenerated,
        errorGeneratedLink: false
      });
      this.cleanState();
    } catch (error) {
      console.log(error.response.statusText);
      this.setState({
        errorGeneratedLink: true,
        errorMessage: error.response.data.message
      });
    }
  };
  cleanState = () => {
    this.setState({
      name: '',
      phoneNumber: '',
      email: '',
      planDetails: '',
      companyId: '',
      companyName: '',
      userPhone: '',
      userEmail: '',
      firstCharge: '',
      errorMessage: '',
      planType: 'GROWTH',
      originalAmount: '',
      duration: '',
      installments: '',
      installmentDuration: '',
      errorCompanyID: false,
      errorDuration: false,
      errorName: false,
      errorPhoneNumber: false,
      errorEmail: false,
      errorPlanDetails: false,
      errorPlanAmount: false,
      errorGeneratedLink: false,
      errorFirstCharge: false,
      disableTextField: true,
      prorationNeeded: false,
      loading: false
    });
  };
  onToggle = () => {
    this.setState({
      showLinkGenerated: !this.state.showLinkGenerated
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        {this.state.showLinkGenerated ? (
          <LinkGenerated
            onToggle={this.onToggle}
            salesLink={this.state.emandateLink}
            mode="e-mandate"
          />
        ) : (
          <Styled.GeneratePaymentLinkContainer>
            <Styled.Title>e-Mandate link generator</Styled.Title>
            <FormControl>
              <Styled.LabelAndTextField>
                <Styled.Label>Company Id</Styled.Label>
                <Styled.InputField>
                  <TextField
                    id="CompanyID"
                    type="text"
                    inputMode={'numeric'}
                    autoComplete="off"
                    className={classes.textField}
                    onBlur={this.getCompanyDetails}
                    onChange={this.companyIdChange}
                    value={this.state.companyId}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    margin="normal"
                  />
                  {this.state.errorCompanyID && (
                    <Styled.Error>Invalid CompanyId</Styled.Error>
                  )}
                  {this.state.prorationNeeded && (
                    <Styled.Error>
                      This company is already on a plan. Can not create
                      e-mandate link for it without expiring the company first.
                    </Styled.Error>
                  )}
                </Styled.InputField>
                {this.state.loading && (
                  <Styled.LoaderContainer>
                    <CircularProgress size={20} thickness={5} color="primary" />
                  </Styled.LoaderContainer>
                )}
              </Styled.LabelAndTextField>
              <Styled.VerifyDetailsContainer>
                Please verify details:
                <Styled.DetailContainer>
                  <Styled.DetailTitle>Company Name</Styled.DetailTitle>
                  <Styled.Label>{this.state.companyName}</Styled.Label>
                </Styled.DetailContainer>
                <Styled.DetailContainer>
                  <Styled.DetailTitle>Phone</Styled.DetailTitle>
                  <Styled.Label>{this.state.userPhone}</Styled.Label>
                </Styled.DetailContainer>
                <Styled.DetailContainer>
                  <Styled.DetailTitle>Email</Styled.DetailTitle>
                  <Styled.Label>{this.state.userEmail}</Styled.Label>
                </Styled.DetailContainer>
                <Styled.DetailContainer>
                  <Styled.DetailTitle>Sales Type</Styled.DetailTitle>
                  {this.state.userEmail && (
                    <Styled.Label>{this.state.salesType}</Styled.Label>
                  )}
                </Styled.DetailContainer>
              </Styled.VerifyDetailsContainer>
              <Styled.LabelAndTextField>
                <Styled.Label>Customer Name</Styled.Label>
                <FormControl>
                  <TextField
                    id="name"
                    autoComplete="off"
                    type="text"
                    className={classes.textField}
                    onChange={this.onNameChange}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    value={this.state.name}
                  />
                  {this.state.errorName && (
                    <Styled.Error>Customer name cannot be empty</Styled.Error>
                  )}
                </FormControl>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>Customer Phone Number</Styled.Label>
                <FormControl>
                  <TextField
                    id="number"
                    autoComplete="off"
                    type="number"
                    className={classes.textField}
                    onChange={this.onPhoneNumberChange}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    value={this.state.phoneNumber}
                  />
                  {this.state.errorPhoneNumber && (
                    <Styled.Error>Invalid customer phone number</Styled.Error>
                  )}
                </FormControl>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>Customer Email</Styled.Label>
                <FormControl>
                  <TextField
                    id="email"
                    autoComplete="off"
                    type="text"
                    className={classes.textField}
                    onChange={this.onEmailChange}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    value={this.state.email}
                  />
                  {this.state.errorEmail && (
                    <Styled.Error>Email cannot be empty</Styled.Error>
                  )}
                </FormControl>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>Plan Type</Styled.Label>
                <FormControl>
                  <Select
                    disabled={this.state.disableTextField}
                    className={classes.textField}
                    value={this.state.planType}
                    onChange={this.onChangeType}
                  >
                    <MenuItem value="GROWTH">GROWTH</MenuItem>
                    <MenuItem value="PLATINUM">PLATINUM</MenuItem>
                    <MenuItem value="PREMIUM">PREMIUM</MenuItem>
                    <MenuItem value="UNLIMITED">UNLIMITED</MenuItem>
                  </Select>
                </FormControl>
              </Styled.LabelAndTextField>

              <Styled.LabelAndTextField>
                <Styled.Label>Max Amount</Styled.Label>
                <Styled.InputField>
                  <TextField
                    id="planAmount"
                    type="number"
                    autoComplete="off"
                    className={classes.textField}
                    value={this.state.originalAmount}
                    onChange={this.planMaxAmountChange}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    margin="normal"
                  />
                  {this.state.errorPlanAmount && (
                    <Styled.Error>
                      Max amount must be greater than 500
                    </Styled.Error>
                  )}
                </Styled.InputField>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.Label>First Charge</Styled.Label>
                <Styled.InputField>
                  <TextField
                    id="firstCharge"
                    type="number"
                    autoComplete="off"
                    className={classes.textField}
                    value={this.state.firstCharge}
                    onChange={this.firstChargeChange}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    margin="normal"
                  />
                  {this.state.errorFirstCharge && (
                    <Styled.Error>Invalid First Charge</Styled.Error>
                  )}
                </Styled.InputField>
              </Styled.LabelAndTextField>

              <Styled.LabelAndTextField>
                <Styled.Label>Duration (months)</Styled.Label>
                <Styled.InputField>
                  <TextField
                    disabled={this.state.disableTextField}
                    id="Duration"
                    type="number"
                    autoComplete="off"
                    className={classes.textField}
                    value={this.state.duration}
                    onChange={this.onDurationChange}
                    classes={{ root: classes.input }}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    margin="normal"
                  />
                  {this.state.errorDuration && (
                    <Styled.Error>
                      Duration must be between 1 and 120
                    </Styled.Error>
                  )}
                </Styled.InputField>
              </Styled.LabelAndTextField>

              <Styled.LabelAndTextField>
                <Styled.Label>Installments</Styled.Label>
                <Styled.InputField>
                  <TextField
                    disabled={this.state.disableTextField}
                    id="Installments"
                    type="number"
                    autoComplete="off"
                    className={classes.textField}
                    value={this.state.installments}
                    onChange={this.onInstallmentsChange}
                    classes={{ root: classes.input }}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    margin="normal"
                  />
                  {this.state.errorInstallments && (
                    <Styled.Error>
                      Total installment duration exceed the duration specified
                    </Styled.Error>
                  )}
                </Styled.InputField>
              </Styled.LabelAndTextField>

              <Styled.LabelAndTextField>
                <Styled.Label>Installment duration (months)</Styled.Label>
                <Styled.InputField>
                  <TextField
                    disabled={this.state.disableTextField}
                    id="Duration"
                    type="number"
                    autoComplete="off"
                    className={classes.textField}
                    value={this.state.installmentDuration}
                    onChange={this.onInstallmentDurationChange}
                    classes={{ root: classes.input }}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    margin="normal"
                  />
                  {this.state.errorInstallmentDuration && (
                    <Styled.Error>
                      Total installment duration exceed the duration specified
                    </Styled.Error>
                  )}
                </Styled.InputField>
              </Styled.LabelAndTextField>

              <Styled.LabelAndTextField>
                <Styled.Label>Plan Details</Styled.Label>
                <FormControl>
                  <TextField
                    id="planDetails"
                    autoComplete="off"
                    type="text"
                    className={classes.textField}
                    onChange={this.onPlanDetailsChange}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      disableUnderline: true,
                      classes: { input: classes.input }
                    }}
                    value={this.state.planDetails}
                  />
                  {this.state.errorPlanDetails && (
                    <Styled.Error>Plan details cannot be empty</Styled.Error>
                  )}
                </FormControl>
              </Styled.LabelAndTextField>
              <Styled.LabelAndTextField>
                <Styled.InputField>
                  <Button
                    tabIndex="-1"
                    type="submit"
                    classes={{ root: classes.button }}
                    onClick={this.onGenerateLink}
                  >
                    Generate e-mandate link
                  </Button>
                  {this.state.errorGeneratedLink && (
                    <Styled.Error>
                      {this.state.errorMessage
                        ? this.state.errorMessage
                        : 'Something went wrong'}
                    </Styled.Error>
                  )}
                </Styled.InputField>
              </Styled.LabelAndTextField>
            </FormControl>
          </Styled.GeneratePaymentLinkContainer>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(GenerateEmandateLink);



// WEBPACK FOOTER //
// ./src/pages/SalesUtility/GenerateEmandateLink/index.js